var btnChevron = {
  "btnChevron": {
    "background": "#f7f8f9",
    "borderColor": "#c8c9c7",
    "color": "#000",
    "&:hover": {
      "background": "#e8ebee"
    },
    "&:active": {
      "background": "#dadfe3"
    },
    "paddingLeft": "0.625rem",
    "textAlign": "left",
    "&::after": {
      "backgroundImage": "url('data:image/svg+xml;utf8,<svg fill=\"%2353565A\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.709 7.294L5.705 1.29a1.002 1.002 0 00-1.413 0 1.001 1.001 0 000 1.413L9.59 8l-5.298 5.296a1.001 1.001 0 000 1.413 1.002 1.002 0 001.413 0l6.004-6.003a1.001 1.001 0 000-1.412z\"/></svg>')",
      "backgroundPosition": "center center",
      "backgroundRepeat": "no-repeat",
      "content": "\"\"",
      "width": "1rem",
      "height": "1rem",
      "fontSize": "1rem",
      "marginRight": "0.375rem",
      "marginTop": "-0.5rem",
      "position": "absolute",
      "right": "0",
      "top": "50%",
      "transition": "color 0.25S ease-out"
    }
  }
};

export { btnChevron as default };
